import styled from 'styled-components';
import Link from 'gatsby-link';
import { colors, sp } from 'styles/theme';

export default styled(Link)`
  display: block;
  color: ${colors.blue};
  margin-bottom: ${sp.s};
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
`;



// WEBPACK FOOTER //
// ./src/components/shared/MainNav/components/SubItem.jsx